import { IonButton, IonIcon } from "@ionic/react";
import React, { FC } from "react";
import { default as add_building_icon} from "../../AE2/static/icons/add_building_icon.svg"

interface IProps {
  uuid:string
}

const AddBuildingButton: FC<IProps> = (props) => {
  return (
      <IonButton
        href={`/customer/${props.uuid}/addproperty`}
        title="Add Building"
        shape="round"  
        color="medium"
      >
        <IonIcon slot="icon-only" src={add_building_icon} />
      </IonButton>
  );
};

export default AddBuildingButton;
